import { DOOR, DOOR_CANOPY } from '../../Constants/ObjectTypes';

export const ChildObjects = [DOOR_CANOPY];

export function isChildObject(type) {
  return ChildObjects.indexOf(type) !== -1;
}

export function findParentForChildObject(objects, type, side, index) {
  switch (type) {
    case DOOR_CANOPY: {
      return objects.find(
        (obj) =>
          obj.side === side &&
          obj.index === index &&
          obj.type === DOOR &&
          !obj.children?.some((o) => o.type === DOOR_CANOPY)
      );
    }
    default: {
      console.error(`Finding parent is not implemented for type: ${type}`);
      return null;
    }
  }
}

export function addChildObjectToParent(parentObject, childObject) {
  childObject.isChild = true;
  if (!parentObject.children) {
    parentObject.children = [];
  }
  parentObject.children.push(childObject);
}

export function removeFromParent(objects, childObject) {
  for (const object of objects) {
    if (object.children?.length) {
      const index = object.children.indexOf(childObject);
      if (index !== -1) {
        object.children.splice(index, 1);
        break;
      }
    }
  }
}
